import { PageHeader } from '../../components/ui/PageHeader.tsx';
import { Link } from 'react-router';
import { useMe } from '../../lib/auth.tsx';
import { useGridQuery, useGridState } from '../../lib/grid.ts';
import { ANCHOR_LABEL, CYCLE_LABEL, dday, type ObligationRow } from '../../lib/schedule.ts';
import { DataTable, type Column } from '../../components/DataTable.tsx';
import { Badge, LinkButton } from '../../components/ui/Button.tsx';
import { PageActions } from '../../components/ui/PageActions.tsx';
import { can } from '../../lib/perm.ts';

const columns: Column<ObligationRow>[] = [
  { key: 'title', label: '의무 일정', filter: 'text', render: (o) => <Link className="text-accent-strong hover:underline" to={`/schedule/obligations/${o.id}`}>{o.title}</Link> },
  { key: 'cycle', label: '주기', width: '5rem', filter: 'select', render: (o) => CYCLE_LABEL[o.cycle] },
  { key: 'anchor', label: '기준', row: 2, span: 1, filter: 'select', render: (o) => o.anchor === 'fixed_date' ? `${o.cycle === 'annual' ? `${o.anchorMonth}월 ` : ''}${o.anchorDay}일` : ANCHOR_LABEL[o.anchor] },
  { key: 'ownerId', label: '담당자', width: '7rem', filter: 'select', sortable: false, render: (o) => o.ownerName || '—' },
  { key: 'deptId', label: '부서', width: '7rem', filter: 'select', sortable: false, render: (o) => o.deptName },
  { key: 'nextDue', label: '다음 기한', width: '9rem', sortable: false, render: (o) => o.nextDue ? <>{o.nextDue.slice(0, 10)} <span className={o.nextDays != null && o.nextDays < 0 ? 'text-red-700' : 'text-slate-500'}>{dday(o.nextDays ?? null)}</span></> : '—' },
  { key: 'lastCompletedAt', label: '마지막 완료', row: 2, span: 1, at: 4, filter: 'date', render: (o) => o.lastCompletedAt?.slice(0, 10) ?? '—' },
  { key: 'isActive', label: '활성', width: '4.5rem', filter: 'bool', align: 'center', render: (o) => o.isActive ? <Badge tone="success">활성</Badge> : <Badge tone="neutral">중지</Badge> },
];

export function ObligationsPage() {
  const me = useMe();
  const { state, set } = useGridState('ob', { sort: { col: 'title', dir: 'asc' } });
  const data = useGridQuery<ObligationRow>('obligations-grid', '/schedule/obligations/grid', state);
  return (
    <div>
      <PageHeader title="의무 일정" />
      {data.isError && <div className="text-red-600 text-sm mb-2">{(data.error as Error).message}</div>}
      <DataTable id="obligations" columns={columns} data={data.data} state={state} onChange={set} isFetching={data.isFetching} />
      <PageActions><LinkButton variant="secondary" to="/schedule/todos">할 일</LinkButton><LinkButton variant="secondary" to="/schedule/calendar">캘린더</LinkButton>{can(me.data, 'schedule.manage') && <LinkButton to="/schedule/obligations/new">의무 일정 등록</LinkButton>}</PageActions>
    </div>
  );
}
